import React, { useEffect, useState } from 'react';
import { UseFormMethods } from 'react-hook-form';
// import ProvisionClause from 'src/components/common/ProvisionClause';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFLegend from 'src/components/controls/tempRHFControls/RHFLegend';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import RHFToggle from 'src/components/controls/tempRHFControls/RHFToggle';
import AdditionalDamages from 'src/models/AdditionalDamages';
import RightOfWay from 'src/models/contract_types/RightOfWay';
import IndexReferenceType from 'src/models/IndexReferenceType';
// import RightOfWay from 'src/models/contract_types/RightOfWay';
import AgreementUtil from 'src/util/AgreementUtil';
import AdditionalDamagesList from '../../AdditionalDamagesList';
import { FormRow } from 'src/components/controls/forms/reactHookForm';
import { rightOfWayLeaseType as rlt } from 'src/components/common/Constants';
import Restriction from 'src/models/leasehold/Restriction';
import RestrictionList from '../../RestrictionList';
import MathUtil from 'src/util/MathUtil';
import * as Constants from 'src/components/common/Constants';

const COST_APPLIED = [
    { value: 'Up Front', label: 'Up Front' },
    { value: 'Balance', label: 'Balance' },
];

const ROW_PAYMENT_OPTIONS = [
    { value: 'Per rod', label: 'Per rod' },
    { value: 'Per foot', label: 'Per foot' },
    { value: 'Flat fee', label: 'Flat fee' },
];

const filterFields: Array<{ field: string, types: Array<string>}> = [
    { field: 'rowLength', types: [rlt.ROW, rlt.LAG, rlt.DOH, rlt.WAV, rlt.SLA, rlt.AGE, rlt.IL, rlt.PAR, rlt.TAR, rlt.TWS, rlt.VAL, rlt.YRD]},
    { field: 'rowWidth', types: [rlt.ROW, rlt.LAG, rlt.PAR, rlt.TAR]},
    { field: 'tempWidth', types: [rlt.ROW, rlt.LAG, rlt.PAR, rlt.TAR]},
    { field: 'constrDate', types: [rlt.TAR, rlt.TWS]},
    { field: 'noLines', types: [rlt.ROW]},
    { field: 'pipeDiameter', types: [rlt.ROW]},
    { field: 'royalty', types: [rlt.ROW, rlt.LAG, rlt.WAV, rlt.SLA, rlt.AGE, rlt.IL, rlt.PAR, rlt.TAR, rlt.TWS, rlt.VAL, rlt.YRD]},
    { field: 'consideration', types: [rlt.ROW, rlt.LAG, rlt.DOH, rlt.WAV, rlt.SLA, rlt.AGE, rlt.IL, rlt.PAR, rlt.TAR, rlt.TWS, rlt.VAL, rlt.YRD]},
    { field: 'extConsideration', types: [rlt.SLA, rlt.IL, rlt.YRD]},
    { field: 'damages', types: [rlt.ROW, rlt.LAG, rlt.SLA, rlt.AGE, rlt.IL, rlt.PAR, rlt.TAR, rlt.TWS, rlt.VAL, rlt.YRD]},
    { field: 'payTermOrder', types: [rlt.ROW, rlt.LAG, rlt.WAV, rlt.SLA, rlt.AGE, rlt.IL, rlt.PAR, rlt.TAR, rlt.TWS, rlt.VAL, rlt.YRD]},
    { field: 'rental', types: [rlt.ROW]},
    { field: 'recordingInfo', types: [rlt.ROW, rlt.SLA, rlt.AGE, rlt.IL, rlt.PAR, rlt.VAL, rlt.YRD]},
    { field: 'addlDamages', types: [rlt.ROW, rlt.SLA, rlt.AGE, rlt.IL, rlt.PAR, rlt.TAR, rlt.TWS, rlt.VAL, rlt.YRD]}
];

interface IRightOfWayGenerationProps extends Partial<Pick<UseFormMethods, 'getValues' | 'setValue' | 'register' | 'errors' | 'reset'>> {
    rightOfWayData: RightOfWay;
    measurementTypes: Array<IndexReferenceType>;
    isInHanded: boolean;
    leaseType: string;
    totalNet?: number;
    calculateTotal: (measurementTypeId: number, paymentAmount: number, grossAcres: number) => number;
    setTotalBonus: (bonusAmount: number) => void;
}

const RightOfWayGeneration = (props: IRightOfWayGenerationProps) => {

    const [additionalDamages, setAdditionalDamages] = useState<Array<AdditionalDamages>>([]);
    const [restrictions, setRestrictions] = useState<Array<Restriction>>([]);
    const [isPerpetual, setIsPerpetual] = useState<boolean>(false);
    const [isRental, setIsRental] = useState<boolean>(false);

    // Total Cost
    const [considerationTotal, setConsiderationTotal] = useState<number>(0);
    // const [signingBonus, setSigningBonus] = useState<number>(0);
    const [initialDamages, setInitialDamages] = useState<number>(0);
    const [upFrontDamages, setUpFrontDamages] = useState<number>(0);
    const [balanceDamages, setBalanceDamages] = useState<number>(0);
    const [totalCosts, setTotalCosts] = useState<number>(0);
    const [rowLengths, setRowLengths] = useState<Array<IndexReferenceType>>([]);
    const [diameterLengths, setDiameterLengths] = useState<Array<IndexReferenceType>>([]);
    const [netLength, setNetLength] = useState<number>(0);

    useEffect(() => {
        if (props?.rightOfWayData) {
            setIsPerpetual(props.rightOfWayData.isPerpetual === true);
            setIsRental(props.rightOfWayData.isRental === true);
            setAdditionalDamages(props.rightOfWayData.rightOfWayHolds?.[0]?.additionalDamages ?? []);
            setRestrictions(props.rightOfWayData.rightOfWayHolds?.[0]?.restrictions ?? []);
        }
    }, [props.rightOfWayData]);

    // TODO: Keeping this commented code in case similar calculations need to be made in the future.

    useEffect(() => {
        if (props?.rightOfWayData !== undefined) {
            handleTotals(props.rightOfWayData);
        }
    }, [props.totalNet, props.rightOfWayData]);

    useEffect(() => {
        if (props.measurementTypes?.length > 0) {
            let rlTypes = props.measurementTypes.filter(rl => rl.name === 'Feet' || rl.name === 'Rods');
            setRowLengths(rlTypes);
            let diamTypes = props.measurementTypes.filter(dt => dt.name === 'Inches' || dt.name === 'Feet');
            setDiameterLengths(diamTypes);
        }
    }, [props.measurementTypes]);

    const handleLengthChange = (e: string) => {
        let eNum = parseFloat(e);
        if (!isNaN(eNum)) {
            setNetLength(eNum);
        }
    };

    const handleTotals = (rep: RightOfWay) => {
        let allTotals = 0;

        let consideration = parseFloat(rep.consideration + '');
        let cTotal = 0;
        if (!isNaN(consideration) && !!rep.considerationType) {
            cTotal = calcRowTotal(rep.considerationType, consideration, netLength);
        }

        let extraConsideration = parseFloat(rep.extraConsideration + '');
        if (!isNaN(extraConsideration) && !!rep.extraConsiderationType) {
            cTotal += calcRowTotal(rep.extraConsiderationType, extraConsideration, netLength);
        }

        let rentalPrice = AgreementUtil.parseBool(isRental + '') === true ? parseFloat(rep.rentalAmount + '') : 0;
        if (rentalPrice > 0 && !!rep.rentalAmountType) {
            cTotal += calcRowTotal(rep.rentalAmountType, rentalPrice, netLength);
        }

        allTotals += cTotal;
        setConsiderationTotal(cTotal);

        let damages = parseFloat(rep.damages + '');
        if (!isNaN(damages) && !!rep.damagesType) {
            let idTotal = calcRowTotal(rep.damagesType, damages, netLength);
            setInitialDamages(idTotal);
            allTotals += idTotal;
        }

        let addlDamages = rep.rightOfWayHolds[0].additionalDamages as unknown as Array<AdditionalDamages>;

        if (addlDamages?.length > 0) {
            let uDamages = addlDamages.filter(ad => ad.costApplied === COST_APPLIED[0].value);
            let upFrontTotal = 0;

            for (let ufd of uDamages) {
                let upFrontAmount = parseFloat(ufd.cost + '');
                if (!isNaN(upFrontAmount) && !!ufd.costType) {
                    let ufTotal = calcRowTotal(ufd.costType, upFrontAmount, netLength);
                    upFrontTotal += ufTotal;
                }
            }
            setUpFrontDamages(upFrontTotal);

            let bDamages = addlDamages.filter(ad => ad.costApplied === COST_APPLIED[1].value);
            let balanceTotal = 0;

            for (let ufd of bDamages) {
                let upFrontAmount = parseFloat(ufd.cost + '');
                if (!isNaN(upFrontAmount) && !!ufd.costType) {
                    let ufTotal = calcRowTotal(ufd.costType, upFrontAmount, netLength);
                    balanceTotal += ufTotal;
                }
            }
            setBalanceDamages(balanceTotal);

            allTotals += upFrontTotal + balanceTotal;
        }

        setTotalCosts(allTotals);
        props.setTotalBonus(allTotals);
        props.setValue('bonusAmount', allTotals);
    };

    const onAddDamages = () => {
        let optionList = [...additionalDamages];
        let newOption = new AdditionalDamages();
        optionList.push(newOption);
        setAdditionalDamages(optionList);
    };
    
    const handleRemoveDamages = (index: number) => {
        let resForm = props.getValues();
        resForm.rightOfWayHolds[0].additionalDamages.splice(index, 1);
        setAdditionalDamages(resForm.rightOfWayHolds[0].additionalDamages);
        
        props.reset(resForm);
        handleTotals(resForm as unknown as RightOfWay);
    };

    const onAddRestrictions = () => {
        let optionList = [...restrictions];
        let newOption = new Restriction();
        optionList.push(newOption);
        setRestrictions(optionList);
    };
    
    const handleRemoveRestrictions = (index: number) => {
        let resForm = props.getValues();
        resForm.rightOfWayHolds[0].restrictions.splice(index, 1);
        setRestrictions(resForm.rightOfWayHolds[0].restrictions);
        
        props.reset(resForm);
    };

    const checkPerpetual = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setIsPerpetual(e.currentTarget.value === 'true');
    };

    const checkRental = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setIsRental(e.currentTarget.value === 'true');
    };

    const calcRowTotal = (
        measurementType: string,
        paymentAmount: number,
        rowNetLength: number
    ) => {
        const rowFactor = Constants.rodToFeetConversion;
        let rowLengthType = parseInt(props.getValues().rowLengthTypeId, 10);
        const lengthType = props.measurementTypes?.find((mt) => mt.id === rowLengthType)?.name;

        switch (measurementType) {
            case 'Flat fee':
                return Number(MathUtil.cleanDollarAmount(paymentAmount));
            case 'Per rod':
                if (lengthType === 'Feet') {
                    rowNetLength /= rowFactor;
                }
                return Number(MathUtil.cleanDollarAmount(paymentAmount * rowNetLength));
            case 'Per foot':
                if (lengthType === 'Rods') {
                    rowNetLength *= rowFactor;
                }
                return Number(MathUtil.cleanDollarAmount(paymentAmount * rowNetLength));
            default:
                return 0;
        }
    };

    // By default, fields inside this check will be hidden unless noted in the filterFields const at the top of the page.
    const handleVisibility = (formRow: string) => {
        let arrIndex = filterFields.find(ff => ff.field === formRow);
        if (arrIndex !== undefined) {
            return arrIndex.types.includes(props.leaseType);
        }
        return false;
    };
    
    return (
        <div>
            <div style={{ margin: '1rem' }}>
                <div style={{ height: '100%', gap: '1rem' }}>
                    <div id="formContent">
                        <div style={{ marginBottom: '2rem' }}>
                            <RHFLegend title="Agreement Terms" />

                            <div hidden={true}>
                                <RHFInputBox
                                    label=""
                                    name="rightOfWayHolds[0].id"
                                    register={props.register}
                                    type="number"
                                    disabled={true}
                                    errors={props.errors}
                                />
                                <RHFInputBox
                                    label=""
                                    name="rightOfWayHolds[0].rightOfWayId"
                                    register={props.register}
                                    type="number"
                                    disabled={true}
                                    errors={props.errors}
                                />
                                <RHFInputBox
                                    label=""
                                    name="rightOfWayHolds[0].projectId"
                                    register={props.register}
                                    type="number"
                                    disabled={true}
                                    errors={props.errors}
                                />
                                <RHFInputBox
                                    label=""
                                    name="rightOfWayHolds[0].rowHoldNumber"
                                    register={props.register}
                                    type="number"
                                    disabled={true}
                                    errors={props.errors}
                                />
                                <RHFInputBox
                                    label=""
                                    name="rightOfWayHolds[0].contractLookupId"
                                    register={props.register}
                                    type="number"
                                    disabled={true}
                                    errors={props.errors}
                                />
                                <RHFInputBox
                                    label="Bonus Amount"
                                    name="bonusAmount"
                                    register={props.register}
                                    errors={props.errors}
                                    disabled={props.isInHanded}
                                />
                            </div>

                            <div className="form-row">
                                <RHFInputBox
                                    rules={{ required: 'field required' }}
                                    type="date"
                                    name="leaseDate"
                                    label="Lease Date"
                                    register={props.register}
                                    errors={props.errors}
                                    isRequired={true}
                                    disabled={props.isInHanded}
                                    bodyStyle={{ width: '33%' }}
                                    style={{ width: '100%' }}
                                />
                                <RHFInputBox
                                    rules={{ required: 'field required' }}
                                    type="date"
                                    name="effectiveDate"
                                    label="Effective Date"
                                    register={props.register}
                                    errors={props.errors}
                                    isRequired={true}
                                    disabled={props.isInHanded}
                                    bodyStyle={{ width: '33%' }}
                                    style={{ width: '100%' }}
                                />
                                {handleVisibility('constrDate') && (
                                    <RHFInputBox
                                        type="date"
                                        name="constraintDate"
                                        label="Constr Date"
                                        register={props.register}
                                        errors={props.errors}
                                        isRequired={true}
                                        disabled={props.isInHanded}
                                        bodyStyle={{ width: '33%' }}
                                        style={{ width: '100%' }}
                                    />
                                )}
                            </div>

                            <div style={{ margin: 'auto 2rem' }}>
                                <div className="form-row">
                                    <RHFInputBox
                                        label="Agent Id"
                                        name="rightOfWayHolds[0].agentId"
                                        register={props.register}
                                        errors={props.errors}
                                        bodyStyle={{ width: '13%' }}
                                        disabled={props.isInHanded}
                                    />
                                    <RHFToggle 
                                        name="isPerpetual" 
                                        label="Is Perpetual?" 
                                        bodyStyle={{ width: '13%' }} 
                                        register={props.register} 
                                        errors={props.errors}
                                        onChange={(e) => checkPerpetual(e)}
                                    />
                                </div>
                                <div className={isPerpetual ? '' : 'form-row'} hidden={isPerpetual}>
                                    <RHFInputBox
                                        label="Primary Term"
                                        name="rightOfWayHolds[0].primaryTerm"
                                        register={props.register}
                                        type="number"
                                        errors={props.errors}
                                        disabled={props.isInHanded}
                                        bodyStyle={{ width: '25%' }}
                                        style={{ width: '100%' }}
                                    />
                                    <RHFSelect
                                        label=" "
                                        name="rightOfWayHolds[0].primaryTermTypeId"
                                        options={AgreementUtil.getOptions(props.measurementTypes, 'Time')}
                                        register={props.register}
                                        errors={props.errors}
                                        disabled={props.isInHanded}
                                        bodyStyle={{ width: '25%' }}
                                        style={{ width: '100%' }}
                                    />
                                    <RHFInputBox
                                        label="Extension Term"
                                        name="rightOfWayHolds[0].extensionTerm"
                                        register={props.register}
                                        type="number"
                                        errors={props.errors}
                                        disabled={props.isInHanded}
                                        bodyStyle={{ width: '25%' }}
                                        style={{ width: '100%' }}
                                    />
                                    <RHFSelect
                                        label=" "
                                        name="rightOfWayHolds[0].extensionTermTypeId"
                                        options={AgreementUtil.getOptions(props.measurementTypes, 'Time')}
                                        register={props.register}
                                        errors={props.errors}
                                        disabled={props.isInHanded}
                                        bodyStyle={{ width: '20%' }}
                                        style={{ width: '100%' }}
                                    />
                                </div>
                            </div>

                            <div style={{ margin: 'auto 2rem' }}>
                                {handleVisibility('noLines') && (
                                    <div className="form-row">
                                        <RHFInputBox
                                            label="No. Lines"
                                            name="numberOfLines"
                                            register={props.register}
                                            type="number"
                                            step={1}
                                            errors={props.errors}
                                            disabled={props.isInHanded}
                                            bodyStyle={{ width: '13%' }}
                                            style={{ width: '100%' }}
                                        />
                                    </div>
                                )}

                                <div className="form-row">
                                    {handleVisibility('rowLength') && (
                                        <>
                                            <RHFInputBox
                                                label="ROW Length"
                                                name="rowLength"
                                                register={props.register}
                                                type="number"
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                                bodyStyle={{ width: '13%' }}
                                                style={{ width: '100%' }}
                                                onChange={(e) => handleLengthChange(e.currentTarget.value)}
                                            />
                                            <RHFSelect
                                                label=" "
                                                name="rowLengthTypeId"
                                                options={AgreementUtil.getOptions(rowLengths, 'Length')}
                                                register={props.register}
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                                bodyStyle={{ width: '12%' }}
                                                style={{ width: '100%' }}
                                                onChange={() => handleTotals(props.getValues() as unknown as RightOfWay)}
                                            />
                                        </>
                                    )}
                                    {handleVisibility('rowWidth') && (
                                        <>
                                            <RHFInputBox
                                                label="ROW Width"
                                                name="rowWidth"
                                                register={props.register}
                                                type="number"
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                                bodyStyle={{ width: '13%' }}
                                                style={{ width: '100%' }}
                                            />
                                            <RHFSelect
                                                label=" "
                                                name="rowWidthTypeId"
                                                options={AgreementUtil.getOptions(rowLengths, 'Length')}
                                                register={props.register}
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                                bodyStyle={{ width: '12%' }}
                                                style={{ width: '100%' }}
                                            />
                                        </>
                                    )}
                                    {handleVisibility('tempWidth') && (
                                        <>
                                            <RHFInputBox
                                                label="Temp Width"
                                                name="tempWidth"
                                                register={props.register}
                                                type="number"
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                                bodyStyle={{ width: '13%' }}
                                                style={{ width: '100%' }}
                                            />
                                            <RHFSelect
                                                label=" "
                                                name="tempWidthTypeId"
                                                options={AgreementUtil.getOptions(rowLengths, 'Length')}
                                                register={props.register}
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                                bodyStyle={{ width: '12%' }}
                                                style={{ width: '100%' }}
                                            />
                                        </>
                                    )}
                                    </div>
                                    <div className="form-row">
                                    {handleVisibility('pipeDiameter') && (
                                        <>
                                            <RHFInputBox
                                                label="Pipeline Diameter"
                                                name="pipeLineSize"
                                                register={props.register}
                                                type="number"
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                                style={{ width: '100%' }}
                                            />
                                            <RHFSelect
                                                label=" "
                                                name="pipeLineSizeTypeId"
                                                options={AgreementUtil.getOptions(diameterLengths, 'Length')}
                                                register={props.register}
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                                style={{ width: '100%' }}
                                            />
                                            <RHFInputBox
                                                label="Not Exceeding"
                                                name="pipeLineNotExceeding"
                                                register={props.register}
                                                type="number"
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                                style={{ width: '100%' }}
                                            />
                                            <RHFSelect
                                                label=" "
                                                name="notExceedingTypeId"
                                                options={AgreementUtil.getOptions(diameterLengths, 'Length')}
                                                register={props.register}
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                                style={{ width: '100%' }}
                                            />
                                        </>
                                    )}
                                </div>
                                <div className="form-row">
                                    {handleVisibility('consideration') && (
                                        <>
                                            <RHFInputBox
                                                label="Consideration"
                                                name="consideration"
                                                register={props.register}
                                                type="number"
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                                style={{ width: '100%' }}
                                                onChange={() => handleTotals(props.getValues() as unknown as RightOfWay)}
                                            />
                                            <RHFSelect
                                                label=" "
                                                name="considerationType"
                                                options={ROW_PAYMENT_OPTIONS}
                                                register={props.register}
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                                style={{ width: '100%' }}
                                                onChange={() => handleTotals(props.getValues() as unknown as RightOfWay)}
                                            />
                                        </>
                                    )}
                                    {handleVisibility('extConsideration') && (
                                        <>
                                            <RHFInputBox
                                                label="Ext. Consideration"
                                                name="extraConsideration"
                                                register={props.register}
                                                type="number"
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                                style={{ width: '100%' }}
                                                onChange={() => handleTotals(props.getValues() as unknown as RightOfWay)}
                                            />
                                            <RHFSelect
                                                label=" "
                                                name="extraConsiderationType"
                                                options={ROW_PAYMENT_OPTIONS}
                                                register={props.register}
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                                style={{ width: '100%' }}
                                                onChange={() => handleTotals(props.getValues() as unknown as RightOfWay)}
                                            />
                                        </>
                                    )}
                                </div>
                                <div className="form-row">
                                    {handleVisibility('damages') && (
                                        <>
                                            <RHFInputBox
                                                label="Damages"
                                                name="damages"
                                                register={props.register}
                                                type="number"
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                                style={{ width: '100%' }}
                                                onChange={() => handleTotals(props.getValues() as unknown as RightOfWay)}
                                            />
                                            <RHFSelect
                                                label=" "
                                                name="damagesType"
                                                options={ROW_PAYMENT_OPTIONS}
                                                register={props.register}
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                                style={{ width: '100%' }}
                                                onChange={() => handleTotals(props.getValues() as unknown as RightOfWay)}
                                            />
                                            <RHFToggle 
                                                name="damagesPaymentUpFront" 
                                                label="Payment Up Front?" 
                                                register={props.register} 
                                                style={{ width: '100%' }}
                                                errors={props.errors} 
                                            />
                                        </>
                                    )}
                                    {handleVisibility('payTermOrder') && (
                                        <>
                                            <RHFInputBox
                                                label="Pay Term Order"
                                                name="payTermOrder"
                                                register={props.register}
                                                type="number"
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                                style={{ width: '100%' }}
                                            />
                                            <RHFSelect
                                                label=" "
                                                name="payTermTypeId"
                                                options={AgreementUtil.getOptions(props.measurementTypes, 'Fee', 'rod')}
                                                register={props.register}
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                                style={{ width: '100%' }}
                                                onChange={() => handleTotals(props.getValues() as unknown as RightOfWay)}
                                            />
                                        </>
                                    )}
                                </div>
                                {handleVisibility('rental') && (
                                    <div className="form-row">
                                        <RHFToggle 
                                            name="isRental" 
                                            label="Rental Agreement?" 
                                            register={props.register} 
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '25%' }}
                                            errors={props.errors} 
                                            onChange={(e) => checkRental(e)}
                                        />
                                        {isRental && (
                                            <>
                                                <RHFInputBox
                                                    label="Rental Amount"
                                                    name="rentalAmount"
                                                    register={props.register}
                                                    type="number"
                                                    errors={props.errors}
                                                    disabled={props.isInHanded}
                                                    bodyStyle={{ width: '25%' }}
                                                    style={{ width: '100%' }}
                                                    onChange={() => handleTotals(props.getValues() as unknown as RightOfWay)}
                                                />
                                                <RHFSelect
                                                    label=" "
                                                    name="rentalAmountType"
                                                    options={ROW_PAYMENT_OPTIONS}
                                                    register={props.register}
                                                    errors={props.errors}
                                                    disabled={props.isInHanded}
                                                    style={{ width: '100%' }}
                                                    bodyStyle={{ width: '25%' }}
                                                    onChange={() => handleTotals(props.getValues() as unknown as RightOfWay)}
                                                />
                                                <RHFInputBox
                                                    label="Escalating Percentage"
                                                    name="rentalEscalatingPercentage"
                                                    register={props.register}
                                                    type="number"
                                                    errors={props.errors}
                                                    disabled={props.isInHanded}
                                                    style={{ width: '100%' }}
                                                    bodyStyle={{ width: '25%' }}
                                                />
                                            </>
                                        )}
                                    </div>
                                )}
                                <div className="form-row">
                                    {handleVisibility('recordingInfo') && (
                                        <>
                                            <RHFSelect
                                                name="recordTypeId"
                                                label="Record Type"
                                                options={[
                                                    { value: 1, label: 'Book/Volume' },
                                                    { value: 2, label: 'Instrument #' },
                                                ]}
                                                register={props.register}
                                                bodyStyle={{ width: '30%' }}
                                                style={{ width: '100%' }}
                                                errors={props.errors}
                                            />
                                            <RHFInputBox
                                                label="Volume"
                                                name="volume"
                                                register={props.register}
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                                style={{ width: '100%' }}
                                            />
                                            <RHFInputBox
                                                label="Page"
                                                name="page"
                                                register={props.register}
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                                style={{ width: '100%' }}
                                            />
                                            <RHFInputBox
                                                type="date"
                                                name="recordDate"
                                                label="Record Date"
                                                register={props.register}
                                                errors={props.errors}
                                                isRequired={true}
                                                disabled={props.isInHanded}
                                                style={{ width: '100%' }}
                                            />
                                        </>
                                    )}
                                </div>
                                <div className="form-row">
                                    {handleVisibility('royalty') && (
                                        <>
                                            <RHFInputBox
                                                label="Royalty"
                                                name="rightOfWayHolds[0].royalty"
                                                register={props.register}
                                                type="number"
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                                style={{ width: '100%' }}
                                            />
                                        </>
                                    )}
                                </div>
                            </div>

                            {handleVisibility('addlDamages') && (
                                <>
                                    <RHFLegend title="Additional Damages" />
                                    <div style={{ margin: '2rem' }}>
                                        <AdditionalDamagesList
                                            additionalDamages={additionalDamages}
                                            measurementTypes={props.measurementTypes}
                                            namePrefix="rightOfWayHolds[0].additionalDamages"
                                            netLength={netLength}
                                            calculateTotals={true}
                                            costApplied={COST_APPLIED}
                                            rowPayOptions={ROW_PAYMENT_OPTIONS}
                                            handleTotals={() => handleTotals(props.getValues() as unknown as RightOfWay)}
                                            calcRowTotal={calcRowTotal}
                                            handleRemoveDamages={handleRemoveDamages}
                                            onAddDamages={onAddDamages}
                                            getValues={props.getValues}
                                            setValue={props.setValue}
                                            register={props.register}
                                            errors={props.errors}
                                        />
                                    </div>
                                </>
                            )}
                            <RHFLegend title="Total Considerations" />

                            <FormRow style={{ marginTop: '1rem' }}>
                                <label className="form-label mr-2">
                                    <b>Total Consideration: </b>
                                    <span className="readonly-field">{considerationTotal}</span>
                                </label>
                                <label className="form-label mr-2">
                                    <b>Initial Damages: </b>
                                    <span className="readonly-field">{initialDamages}</span>
                                </label>
                                <label className="form-label mr-2">
                                    <b>Up Front Damages: </b>
                                    <span className="readonly-field">{upFrontDamages}</span>
                                </label>
                                <label className="form-label mr-2">
                                    <b>Balance Damages: </b>
                                    <span className="readonly-field">{balanceDamages}</span>
                                </label>
                                <label className="form-label mr-2">
                                    <b>Total Costs: </b>
                                    <span className="readonly-field">{totalCosts}</span>
                                </label>
                            </FormRow>

                            <RHFLegend title="Restrictions" />
                            <div style={{ margin: '2rem' }}>
                                <RestrictionList
                                    restrictions={restrictions}
                                    namePrefix="rightOfWayHolds[0].restrictions"
                                    handleRemoveRestrictions={handleRemoveRestrictions}
                                    onAddRestriction={onAddRestrictions}
                                    getValues={props.getValues}
                                    setValue={props.setValue}
                                    register={props.register}
                                    errors={props.errors}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RightOfWayGeneration;


// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/redesign/RightOfWayComponents/RightOfWayGeneration.tsx